import { isTypedObject } from "./typed-object.js";
export const SynchronousWritableEntityModelType = "synchronous-writable-entity-model";
export function isSynchronousWritableEntityModel(what) {
    return isTypedObject(what) && what.getTypes().includes(SynchronousWritableEntityModelType);
}
//# sourceMappingURL=on-premise-writable-entity-model.js.map